import React from 'react';

import useUrlState from '@dashboard/hooks/useUrlState';
import useTableSort from '@dashboard/hooks/useTableSort';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import ExportView from '@dashboard/components/ExportView';
import SearchInput from '@dashboard/components/Form/components/SearchInput';
import CustomersList from '../components/CustomersList';

const PageCustomers = ({ page }) => {
  const [query, setParams] = useUrlState();
  const { sorting, onSortingChange, sort } = useTableSort();

  const search = query.search || '';

  const filter = {};

  let title = 'customers';
  if (page.type === 'form') {
    title = 'leads';
  } else if (page.type === 'event') {
    title = 'guests';
  }

  const handleSearchChange = value => setParams({ search: value || undefined });

  return (
    <div className="mb-24">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 pb-4">
        <CardHeaderTitle variant="page">
          {title.charAt(0).toUpperCase() + title.slice(1)}
        </CardHeaderTitle>

        <div className="flex flex-wrap items-center gap-2 max-lg:w-full [&>*:first-child]:min-w-0 max-lg:[&>*:first-child]:flex-1 max-lg:[&>*:first-child]:basis-56 max-sm:[&>*:first-child]:basis-full">
          <SearchInput
            onChange={handleSearchChange}
            name="search_customers"
            placeholder="Search by email"
            initialValue={search}
          />

          <ExportView
            collection="checkout-customers"
            label={title}
            filters={{
              page: page._id,
            }}
          />
        </div>
      </div>

      <div className="overflow-auto mb-20">
        <CustomersList
          sort={sort}
          search={search}
          filter={filter}
          sorting={sorting}
          onSortingChange={onSortingChange}
        />
      </div>
    </div>
  );
};

export default PageCustomers;
